// Transcription timestamps often miss the first consonant or final release.
// Give NEW, untouched word-aligned selects modest handles. Manual Refine edits
// are authoritative and are never recalculated by this helper.
export const SPEECH_PRE_ROLL_SECONDS = 0.18;
export const SPEECH_POST_ROLL_SECONDS = 0.24;

export function speechHandleRange(words, range, duration) {
  if (!Array.isArray(words) || !Number.isFinite(duration) ||
    !Number.isFinite(range?.start) || !Number.isFinite(range?.end) ||
    range.start < 0 || range.end <= range.start || range.end > duration) {
    return {...range};
  }
  // Only pad real word boundaries; never reinterpret a deliberate hand trim.
  const first = words.findIndex(word => word.start === range.start && word.end > word.start);
  const last = words.findLastIndex(word => word.end === range.end && word.end > word.start);
  if (first < 0 || last < first) return {...range};

  const preceding = words[first - 1], following = words[last + 1];
  // Never push the cut into an UNSELECTED neighbour's annotated word.
  // For a tight, uninterrupted sentence there may be no safe spare handle:
  // that edit remains available for frame-accurate adjustment in Refine.
  const earliest = Number.isFinite(preceding?.end)
    ? Math.min(range.start, Math.max(0, preceding.end)) : 0;
  const latest = Number.isFinite(following?.start)
    ? Math.max(range.end, Math.min(duration, following.start)) : duration;
  return {
    start: Math.max(0, earliest, range.start - SPEECH_PRE_ROLL_SECONDS),
    end: Math.min(duration, latest, range.end + SPEECH_POST_ROLL_SECONDS)
  };
}
